import { id, root } from './user-search';

export const userSearch = {
  ...root,
  id,
};
